module.exports = __webpack_public_path__ + "img/biaozhun-guanggao.0d8b218c.svg";